import { Action } from '@ngrx/store';

// Interfaces
import { Account } from '../interfaces/account.interface';
import { Phone, Phone2FA } from '../interfaces/phone.interface';
import { CodeType } from '../../staff/models/accounts.model';

// Constants - Export Constants
export const TOGGLE_2FA_MODAL = '[My Account] Toggle 2FA Modal';
export const TOGGLE_LICENSE_MODAL = '[My Account] Toggle License Agreement Modal';
export const TOGGLE_2FA_CONF_MODAL = '[My Account] Toggle 2FA Config Modal';
export const TOGGLE_2FA_CODE_CONF_MODAL = '[My Account] Toggle 2FA Code Config Modal';
export const TOGGLE_2FA_EMAIL_CONF_MODAL = '[My Account] Toggle 2FA Email Config Modal';
export const TOGGLE_PRIVACY_MODAL = '[My Account] Toggle Privacy Modal';
export const TOGGLE_TERMS_MODAL = '[My Account] Toggle Terms Modal';
export const TOGGLE_CHANGE_PASSWORD_MODAL = '[My Account] Toggle Change Password Modal';
// Constants - General Settings
export const REMOVE_PHONE_2FA = '[My Account] Remove Phone Number With 2FA Enabled';
export const EMAIL_VERIFICATION = '[My Account] Email Verification';
export const TFA_PHONE_REQUIRED = '[My Account] Phone Required To Enable 2FA';
export const UPDATE_CLIENT_PHONE = '[My Account] Update Client Phone';
export const EMAIL_CHANGE_CANCELED = '[My Account] Email Change Canceled';
export const UPDATE_CLIENT_ACCOUNT = '[My Account] Update Client Account';
export const VALIDATE_EMAIL_ADDRESS = '[My Account] Validate Email Address';
export const EMAIL_VERIFICATION_FAIL = '[My Account] Email Verification FAIL';
export const RESET_BASIC_INFORMATION = '[My Account] Reset Basic Information';
export const UPDATE_CLIENT_PHONE_2FA = '[My Account] Update Client Phone With 2FA';
export const SEND_CODE_TO_EMAIL_ADDRESS = '[My Account] Send Validation Code To Email Address';
export const UPDATE_CLIENT_PHONE_SUCCESS = '[My Account] Update Client Phone Success';
export const UPDATE_CLIENT_PHONE_2FA_CALL = '[My Account] 2FA Verification Phone Call';
export const UPDATE_CLIENT_PHONE_2FA_CODE = '[My Account] Send 2FA Code For Update Client Phone';
export const UPDATE_CLIENT_PHONE_2FA_FAIL = '[My Account] Update Client Phone 2FA Fail';
export const DISABLING_2FA_TO_REMOVE_PHONE = '[My Account] Desable 2FA To Remove Modal';
export const UPDATE_CLIENT_ACCOUNT_SUCCESS = '[My Account] Update Client Account Success';
export const UPDATE_CLIENT_PHONE_2FA_CANCEL = '[My Account] Update Client Phone 2FA Cancel';
export const VALIDATE_EMAIL_ADDRESS_SUCCESS = '[My Account] Validate Email Address Success';
export const RESTORE_EMAIL_VERIFICATION_FAIL = '[My Account] Restore Email Verification FAIL Status';
export const UPDATE_CLIENT_PHONE_2FA_SUCCESS = '[My Account] Update Client Phone 2FA Success';
export const CLOSE_VALIDATE_EMAIL_ADDRESS_MODAL = '[My Account] Close Validate Email Address Modal';
export const UPDATE_CLIENT_PHONE_2FA_CALL_SUCCESS = '[My Account] 2FA Verification Phone Call Success';
export const UPDATE_CLIENT_PHONE_2FA_CALL_FAIL = '[My Account] 2FA Verification Phone Call Fail';
export const UPDATE_CLIENT_PHONE_2FA_CODE_SUCCESS = '[My Account] Send 2FA Code For Update Client Phone';
// Constants - Security
export const CHANGE_CLIENT_PASSWORD = '[My Account] Change Client Password';
export const CHANGE_CLIENT_PASSWORD_FAIL = '[My Account] Change Client Password Fail';
export const CHANGE_CLIENT_PASSWORD_SUCCESS = '[My Account] Change Client Password Success';
export const UPDATE_CLIENT_2FA_CONFIGURATION = '[My Account] Update Client 2FA Configuration';
export const UPDATE_CLIENT_2FA_URI = '[My Account] Update Client 2FA URI';
export const VERIFY_CLIENT_2FA_CONFIGURATION = '[My Account] Verify Client 2FA Configuration';
export const VERIFY_CLIENT_2FA_CONFIGURATION_FAIL = '[My Account] Verify Client 2FA Configuration Fail';
export const UPDATE_CLIENT_2FA_CONFIGURATION_SUCCESS = '[My Account] Update Client 2FA Configuration Success';
export const VERIFY_CLIENT_2FA_CONFIGURATION_SUCCESS = '[My Account] Verify Client 2FA Configuration Success';
export const UPDATE_CLIENT_2FA_CONFIGURATION_REMOVE_PHONE = '[My Account] Update Client 2FA Configuration Then Remove Phone';
// Constants - License Agreement
export const DECLINE_LICENSE = '[My Account] Decline License';
export const LICENSE_AGREEMENT = '[My Account] Accepting License';
export const GET_LICENSE_AGREEMENT = '[My Account] Get License Agreement';
export const GET_PRIVACY = '[My Account] Get Privacy';
export const GET_TERMS = '[My Account] Get Terms';
export const LICENSE_AGREEMENT_SUCCESS = '[My Account] Accepting License Success';
export const CLOSE_DECLINED_LICENSE_MODAL = '[My Account] Close Declined License Modal';
export const GET_LICENSE_AGREEMENT_SUCCESS = '[My Account] Get License Agreement Success';
export const GET_PRIVACY_SUCCESS = '[My Account] Get Privacy Success';
export const GET_TERMS_SUCCESS = '[My Account] Get Terms Success';
// Constants - My Projects
export const GET_CLIENT_PROJECTS = '[My Account] Get Client Projects';
export const GET_CLIENT_PROJECTS_SUCCESS = '[My Account] Get Client Projects Success';


// Actions - Basic
export class Toggle2FAModal implements Action {
  readonly type = TOGGLE_2FA_MODAL;
}
export class Toggle2FAConfModal implements Action {
  readonly type = TOGGLE_2FA_CONF_MODAL;
}
export class Toggle2FACodeConfModal implements Action {
  readonly type = TOGGLE_2FA_CODE_CONF_MODAL;
}
export class Toggle2FAEmailConfModal implements Action {
  readonly type = TOGGLE_2FA_EMAIL_CONF_MODAL;
}
export class ToggleLicenseModal implements Action {
  readonly type = TOGGLE_LICENSE_MODAL;
}
export class TogglePrivacyModal implements Action {
  readonly type = TOGGLE_PRIVACY_MODAL;
}
export class ToggleTermsModal implements Action {
  readonly type = TOGGLE_TERMS_MODAL;
}
export class ToggleChangePasswordModal implements Action {
  readonly type = TOGGLE_CHANGE_PASSWORD_MODAL;
}

// Actions - General Settings
export class RemovePhone2FA implements Action {
  readonly type = REMOVE_PHONE_2FA;
}
export class PhoneRequired2FA implements Action {
  readonly type = TFA_PHONE_REQUIRED;
}
export class EmailVerification implements Action {
  readonly type = EMAIL_VERIFICATION;
  constructor(public payload: { email: string }) {}
}
export class UpdateClientPhone implements Action {
  readonly type = UPDATE_CLIENT_PHONE;
  constructor(public payload: Phone) {}
}
export class EmailChangeCanceled implements Action {
  readonly type = EMAIL_CHANGE_CANCELED;
}
export class UpdateClientAccount implements Action {
  readonly type = UPDATE_CLIENT_ACCOUNT;
  constructor(public payload: Account) {}
}
export class UpdateClientPhone2FA implements Action {
  readonly type = UPDATE_CLIENT_PHONE_2FA;
  constructor(public payload: Phone2FA) {}
}
export class ValidateEmailAddress implements Action {
  readonly type = VALIDATE_EMAIL_ADDRESS;
  constructor(public payload: { email: string, email_code: string }) {}
}
export class EmailVerificationFail implements Action {
  readonly type = EMAIL_VERIFICATION_FAIL;
  constructor(public payload: string) {}
}
export class ResetBasicInformation implements Action {
  readonly type = RESET_BASIC_INFORMATION;
}
export class UpdateClientPhone2FACall implements Action {
  readonly type = UPDATE_CLIENT_PHONE_2FA_CALL;
  constructor(public payload: Phone) {}
}
export class UpdateClientPhone2FACode implements Action {
  readonly type = UPDATE_CLIENT_PHONE_2FA_CODE;
  constructor(public payload: Phone) {}
}
export class UpdateClientPhone2FAFail implements Action {
  readonly type = UPDATE_CLIENT_PHONE_2FA_FAIL;
  constructor(public payload: string) {}
}
export class UpdateClientPhone2FACallFail implements Action {
  readonly type = UPDATE_CLIENT_PHONE_2FA_CALL_FAIL;
  constructor(public payload: string) {}
}
export class UpdateClientPhoneSuccess implements Action {
  readonly type = UPDATE_CLIENT_PHONE_SUCCESS;
}
export class Disabling2FAToRemovePhone implements Action {
  readonly type = DISABLING_2FA_TO_REMOVE_PHONE;
  constructor(public peyload: any) {}
}
export class SendValidationCodeToEmail implements Action {
  readonly type = SEND_CODE_TO_EMAIL_ADDRESS;
  constructor(public payload: { email: string }) {}
}
export class UpdateClientAccountSuccess implements Action {
  readonly type = UPDATE_CLIENT_ACCOUNT_SUCCESS;
}
export class UpdateClientPhone2FACancel implements Action {
  readonly type = UPDATE_CLIENT_PHONE_2FA_CANCEL;
}
export class UpdateClientPhone2FASuccess implements Action {
  readonly type = UPDATE_CLIENT_PHONE_2FA_SUCCESS;
}
export class ValidateEmailAddressSuccess implements Action {
  readonly type = VALIDATE_EMAIL_ADDRESS_SUCCESS;
}
export class RestoreEmailVerificationFail implements Action {
  readonly type = RESTORE_EMAIL_VERIFICATION_FAIL;
}
export class CloseValidateEmailAddressModal implements Action {
  readonly type = CLOSE_VALIDATE_EMAIL_ADDRESS_MODAL;
}
export class UpdateClientPhone2FACallSuccess implements Action {
  readonly type = UPDATE_CLIENT_PHONE_2FA_CALL_SUCCESS;
}
export class UpdateClientPhone2FACodeSuccess implements Action {
  readonly type = UPDATE_CLIENT_PHONE_2FA_CODE_SUCCESS;
}

// Actions - Security
export class ChangeClientPassword implements Action {
  readonly type = CHANGE_CLIENT_PASSWORD;
  constructor(public payload: any) {}
}
export class ChangeClientPasswordFail implements Action {
  readonly type = CHANGE_CLIENT_PASSWORD_FAIL;
  constructor(public payload: string) {}
}
export class ChangeClientPasswordSuccess implements Action {
  readonly type = CHANGE_CLIENT_PASSWORD_SUCCESS;
}
export class UpdateClient2FAConfiguration implements Action {
  readonly type = UPDATE_CLIENT_2FA_CONFIGURATION;
  constructor(public payload: { usrTfa: number, factor_authentication?: number, mfa_uri?: string }) {}
}
export class UpdateClient2FAUri implements Action {
  readonly type = UPDATE_CLIENT_2FA_URI;
  constructor(public payload: string) {}
}
export class VerifyClient2FAConfiguration implements Action {
  readonly type = VERIFY_CLIENT_2FA_CONFIGURATION;
  constructor(public payload: { tfaCode: string, tfaType: CodeType }) {}
}
export class VerifyClient2FAConfigurationFail implements Action {
  readonly type = VERIFY_CLIENT_2FA_CONFIGURATION_FAIL;
  constructor(public payload: string) {}
}
export class UpdateClient2FAConfigurationSuccess implements Action {
  readonly type = UPDATE_CLIENT_2FA_CONFIGURATION_SUCCESS;
}
export class VerifyClient2FAConfigurationSuccess implements Action {
  readonly type = VERIFY_CLIENT_2FA_CONFIGURATION_SUCCESS;
}
export class UpdateClient2FAConfigurationRemovePhone implements Action {
  readonly type = UPDATE_CLIENT_2FA_CONFIGURATION_REMOVE_PHONE;
  constructor(public payload: any) {}
}

// Actions - License Agreement
export class GetTerms implements Action {
  readonly type = GET_TERMS;
  constructor(public payload?: string) {}
}
export class GetPrivacy implements Action {
  readonly type = GET_PRIVACY;
  constructor(public payload?: string) {}
}
export class DeclineLicense implements Action {
  readonly type = DECLINE_LICENSE;
}
export class GetTermsSuccess implements Action {
  readonly type = GET_TERMS_SUCCESS;
  constructor(public payload: string) {}
}
export class LicenseAgreement implements Action {
  readonly type = LICENSE_AGREEMENT;
  constructor(public payload: number) {}
}
export class GetPrivacySuccess implements Action {
  readonly type = GET_PRIVACY_SUCCESS;
  constructor(public payload: string) {}
}
export class GetLicenseAgreement implements Action {
  readonly type = GET_LICENSE_AGREEMENT;
  constructor(public payload: string) {}
}
export class LicenseAgreementSuccess implements Action {
  readonly type = LICENSE_AGREEMENT_SUCCESS;
}
export class CloseDeclinedLicenseModal implements Action {
  readonly type = CLOSE_DECLINED_LICENSE_MODAL;
}
export class GetLicenseAgreementSuccess implements Action {
  readonly type = GET_LICENSE_AGREEMENT_SUCCESS;
  constructor(public payload: string) {}
}

// Actions - Get My Projects
export class GetClientProjects implements Action {
  readonly type = GET_CLIENT_PROJECTS;
}
export class GetClientProjectsSuccess implements Action {
  readonly type = GET_CLIENT_PROJECTS_SUCCESS;
  constructor(public payload: Array<any>) {}
}


// Export Actions
export type Actions =
  | GetTerms
  | GetPrivacy
  | DeclineLicense
  | RemovePhone2FA
  | Toggle2FAModal
  | GetTermsSuccess
  | LicenseAgreement
  | PhoneRequired2FA
  | ToggleTermsModal
  | EmailVerification
  | GetClientProjects
  | GetPrivacySuccess
  | UpdateClientPhone
  | Toggle2FAConfModal
  | Toggle2FACodeConfModal
  | Toggle2FAEmailConfModal
  | ToggleLicenseModal
  | TogglePrivacyModal
  | EmailChangeCanceled
  | GetLicenseAgreement
  | UpdateClientAccount
  | ChangeClientPassword
  | UpdateClientPhone2FA
  | ValidateEmailAddress
  | EmailVerificationFail
  | ResetBasicInformation
  | LicenseAgreementSuccess
  | ChangeClientPasswordFail
  | GetClientProjectsSuccess
  | UpdateClientPhone2FACall
  | UpdateClientPhone2FACode
  | UpdateClientPhone2FAFail
  | UpdateClientPhoneSuccess
  | CloseDeclinedLicenseModal
  | Disabling2FAToRemovePhone
  | SendValidationCodeToEmail
  | ToggleChangePasswordModal
  | GetLicenseAgreementSuccess
  | UpdateClientAccountSuccess
  | UpdateClientPhone2FACancel
  | ChangeClientPasswordSuccess
  | UpdateClientPhone2FASuccess
  | ValidateEmailAddressSuccess
  | RestoreEmailVerificationFail
  | UpdateClient2FAConfiguration
  | UpdateClient2FAUri
  | VerifyClient2FAConfiguration
  | CloseValidateEmailAddressModal
  | UpdateClientPhone2FACallSuccess
  | UpdateClientPhone2FACodeSuccess
  | VerifyClient2FAConfigurationFail
  | UpdateClient2FAConfigurationSuccess
  | VerifyClient2FAConfigurationSuccess
  | UpdateClient2FAConfigurationRemovePhone
  | UpdateClientPhone2FACallFail;



// WEBPACK FOOTER //
// ./src/app/my-account/actions/account.actions.ts